import { createContext, useContext } from "react";
import { type DropdownEntry } from "~/common/types";

const OptimeCountriesContext = createContext<{
  countriesList: DropdownEntry<string>[];
  countryByCode: Dict<string>;
}>({ countriesList: [], countryByCode: {} });

export const CheckoutCountriesContextProvider = OptimeCountriesContext.Provider;

export const useOptimeCountries = () => useContext(OptimeCountriesContext);
